import PropTypes from 'prop-types';
import { Link as RouterLink } from 'react-router-dom';
import { useTheme } from '@mui/material/styles';
import { Box } from '@mui/material';

Logo.propTypes = {
  disabledLink: PropTypes.bool,
  sx: PropTypes.object,
};

export default function Logo({ disabledLink = false, sx }) {
  const theme = useTheme();
  const PRIMARY_LIGHT = theme.palette.primary.light;
  const PRIMARY_MAIN = theme.palette.primary.main;
  const PRIMARY_DARK = theme.palette.primary.dark;
  const logo = (
    <Box sx={{ width: 40, height: 40, ...sx }}>
      <svg xmlns="http://www.w3.org/2000/svg" width="100%" height="100%" viewBox="0 0 1080.000000 1080.000000">
        <defs>
          <linearGradient id="BG1" x1="100%" x2="50%" y1="9.946%" y2="50%">
            <stop offset="0%" stopColor={PRIMARY_DARK} />
            <stop offset="100%" stopColor={PRIMARY_MAIN} />
          </linearGradient>
          <linearGradient id="BG2" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stopColor={PRIMARY_LIGHT} />
            <stop offset="100%" stopColor={PRIMARY_MAIN} />
          </linearGradient>
          <linearGradient id="BG3" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stopColor={PRIMARY_LIGHT} />
            <stop offset="100%" stopColor={PRIMARY_MAIN} />
          </linearGradient>
        </defs>
       
<g transform="translate(0.000000,1080.000000) scale(0.100000,-0.100000)"
fill="#000000" stroke="none">
<path d="M4458 5863 c-14 -15 -42 -54 -62 -86 -180 -283 -172 -656 17 -939 69
-102 88 -119 115 -102 31 20 25 50 -23 116 -76 102 -121 209 -144 342 -32 179
15 399 118 555 67 100 67 99 55 118 -17 28 -47 26 -76 -4z"/>
<path d="M6272 5878 c-20 -20 -14 -39 29 -100 203 -290 195 -659 -20 -947 -37
-49 -40 -57 -27 -75 22 -35 50 -31 82 11 80 105 131 203 165 318 21 69 24 101
24 235 0 204 -29 310 -128 465 -62 98 -96 122 -125 93z"/>
<path d="M4703 5728 c-65 -71 -123 -200 -144 -318 -26 -150 25 -351 125 -487
33 -45 53 -57 79 -47 32 12 30 43 -6 92 -155 212 -156 469 -4 690 25 37 28 48
18 68 -13 30 -41 31 -68 2z"/>
<path d="M6032 5738 c-19 -19 -14 -42 17 -85 50 -69 79 -136 97 -224 34 -169
-4 -329 -114 -476 -27 -36 -23 -68 8 -78 27 -9 34 -2 86 68 89 122 135 305
115 452 -13 90 -44 183 -84 250 -56 94 -95 123 -125 93z"/>
<path d="M5324 5577 c-85 -24 -156 -94 -189 -186 -32 -91 -9 -187 63 -260 26
-27 55 -52 64 -57 20 -11 16 -33 -72 -514 -22 -124 -52 -286 -65 -360 -13 -74
-31 -178 -41 -231 -9 -52 -14 -108 -10 -122 l6 -27 324 0 c361 0 352 -2 344
67 -3 21 -58 292 -124 602 l-118 564 29 21 c112 79 159 188 129 303 -25 98
-95 170 -192 199 -53 16 -92 16 -148 1z"/>
<path d="M4892 5511 c-17 -23 -38 -70 -47 -106 -23 -84 -15 -159 26 -243 32
-66 65 -97 92 -86 31 12 30 43 -4 97 -29 45 -34 63 -37 130 -4 73 -2 83 29
144 25 50 30 69 22 81 -20 32 -50 26 -81 -17z"/>
<path d="M5832 5538 c-18 -18 -15 -33 18 -95 25 -46 30 -67 30 -124 0 -58 -5
-77 -35 -135 -35 -68 -38 -97 -9 -108 59 -23 143 152 131 272 -6 53 -45 152
-74 184 -19 21 -44 23 -61 6z"/>
<path d="M1463 3331 c-103 -26 -206 -110 -253 -206 -22 -44 -25 -63 -25 -160
0 -106 1 -112 34 -173 42 -77 94 -125 179 -165 60 -28 76 -31 162 -31 105 1
188 20 258 60 l43 25 -3 147 -3 147 -70 0 -70 0 -3 -107 -3 -108 -54 -15
c-118 -35 -237 14 -293 120 -25 46 -21 160 6 213 25 46 84 94 139 113 76 25
193 -2 248 -58 13 -13 21 -8 67 36 l53 51 -38 35 c-59 53 -135 78 -247 81 -52
2 -110 -1 -127 -5z"/>
<path d="M5719 3326 c-100 -29 -201 -113 -240 -201 -44 -100 -40 -228 10 -330
39 -80 100 -134 189 -170 56 -23 82 -28 162 -28 127 0 210 32 291 113 75 75
103 144 102 260 0 106 -28 175 -103 254 -73 78 -147 108 -270 112 -58 2 -113
-2 -141 -10z m230 -152 c95 -48 139 -157 111 -276 -18 -74 -86 -141 -159 -157
-136 -29 -258 47 -283 176 -37 198 153 345 331 257z"/>
<path d="M1966 3308 c25 -84 189 -585 208 -638 l24 -65 88 0 88 0 80 238 c43
130 82 237 85 237 4 0 42 -108 85 -240 l78 -240 88 0 89 0 117 358 c64 196
118 360 121 365 2 4 -32 7 -75 7 l-79 0 -26 -72 c-14 -40 -51 -152 -82 -248
-31 -96 -60 -178 -64 -182 -4 -4 -44 107 -89 248 l-83 255 -76 -3 -76 -3 -83
-249 c-46 -137 -85 -251 -88 -253 -2 -3 -32 82 -66 189 -33 106 -71 221 -82
256 l-22 62 -84 0 c-82 0 -83 0 -76 -22z"/>
<path d="M3420 3244 c-22 -47 -40 -87 -40 -89 0 -2 -15 -36 -33 -77 -19 -40
-48 -104 -65 -143 -17 -38 -56 -126 -87 -194 -30 -68 -55 -126 -55 -127 0 -2
37 -4 83 -4 l82 1 28 62 c15 34 27 68 27 75 0 10 39 12 176 10 l176 -3 30 -72
31 -73 83 0 c46 0 84 3 84 6 0 5 -96 223 -283 641 l-32 72 -83 1 -83 0 -39
-86z m178 -213 c29 -71 52 -132 52 -137 0 -5 -49 -9 -110 -9 -60 0 -110 4
-110 9 0 15 104 266 110 266 3 0 29 -58 58 -129z"/>
<path d="M4037 3323 c-4 -3 -7 -168 -7 -365 l0 -358 80 0 80 0 0 100 0 100 83
0 82 -1 65 -99 65 -99 88 -1 c102 0 102 -13 3 129 -36 52 -66 98 -66 102 0 4
8 10 18 13 29 10 84 68 103 111 22 48 25 161 6 208 -38 90 -122 143 -250 157
-94 11 -340 13 -350 3z m376 -144 c69 -35 94 -106 62 -173 -27 -56 -63 -70
-180 -71 l-100 0 -3 128 -3 127 101 0 c56 0 111 -5 123 -11z"/>
<path d="M4752 3263 l3 -68 192 -5 191 -5 -170 -205 c-93 -113 -183 -220 -199
-238 -27 -29 -30 -39 -27 -85 l3 -52 318 -3 317 -2 0 64 c0 51 -3 65 -17 70
-9 4 -98 6 -197 6 -100 0 -185 -1 -190 0 -8 0 23 44 66 95 9 11 84 102 167
202 l151 182 0 55 0 56 -305 0 -306 0 3 -67z"/>
<path d="M6660 2965 l0 -367 223 5 c188 4 229 8 267 24 141 59 209 140 233
277 21 126 -19 244 -113 328 -87 78 -140 90 -397 96 l-213 4 0 -367z m446 198
c76 -40 114 -107 114 -198 0 -68 -20 -117 -64 -161 -52 -52 -93 -64 -228 -64
l-106 0 0 217 c0 120 2 221 5 226 3 5 58 7 122 5 95 -3 124 -8 157 -25z"/>
<path d="M7710 3245 c-22 -46 -40 -87 -40 -89 0 -3 -13 -33 -30 -68 -25 -53
-191 -427 -207 -465 -4 -10 16 -13 79 -13 l84 0 30 73 30 72 173 0 173 0 30
-72 31 -73 83 0 c46 0 84 2 84 4 0 6 -61 148 -95 221 -35 76 -193 431 -208
468 -11 26 -13 27 -95 27 l-83 0 -39 -85z m133 -102 c3 -10 26 -68 51 -130 25
-61 46 -115 46 -120 0 -4 -50 -8 -110 -8 -61 0 -110 4 -110 9 0 18 103 266
110 266 4 0 10 -8 13 -17z"/>
<path d="M8240 3260 l0 -70 115 0 115 0 0 -295 0 -295 83 0 82 0 0 292 0 293
118 3 118 3 -3 67 -3 67 -312 3 -313 2 0 -70z"/>
<path d="M9150 3245 c-22 -46 -40 -87 -40 -89 0 -3 -13 -33 -30 -68 -25 -53
-191 -427 -207 -465 -4 -10 16 -13 79 -13 l84 0 30 73 30 72 173 0 173 0 30
-72 31 -73 83 0 c46 0 84 2 84 5 0 4 -58 139 -97 225 -40 86 -194 432 -206
463 -11 26 -13 27 -95 27 l-83 0 -39 -85z m133 -102 c3 -10 26 -68 51 -130 25
-61 46 -115 46 -120 0 -4 -50 -8 -110 -8 -61 0 -110 4 -110 9 0 18 103 266
110 266 4 0 10 -8 13 -17z"/>
</g>
</svg>



    </Box>
  );
  if (disabledLink) {
    return <>{logo}</>;
  }

  return <RouterLink to="">{logo}</RouterLink>
}
